import React, { useState } from 'react';
import './InputSearch.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import useAuthUser from '../../useAuthUser';

export default function InputSearch() {
    const { isAdmin } = useAuthUser();
    const [searchTerm, setSearchTerm] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const enlaces = [
        { title: 'Productos', link: '/dashboard/productos' },
        { title: 'Categorías', link: '/dashboard/categorias' },
        { title: 'Eventos', link: '/dashboard/eventos' },
        { title: 'Centros de Servicios', link: '/dashboard/centros-servicios' },
        { title: 'Banners', link: '/dashboard/banners' },
        { title: 'Contacto', link: '/dashboard/contacto' },
        { title: 'Usuarios', link: '/dashboard/usuarios', adminOnly: true },
        { title: 'Códigos', link: '/dashboard/codigos' },
        { title: 'Configuración', link: '/dashboard/configuracion', adminOnly: true },
    ].filter(item => !item.adminOnly || isAdmin);



    const handleSearch = (event) => {
        const searchTerm = event.target.value;
        setSearchTerm(searchTerm);
        setModalOpen(searchTerm !== "");
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const filteredEnlaces = enlaces.filter((enlace) =>
        enlace.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (


        <div className="inputSearchDashboard">
            <div className='search'>
                <FontAwesomeIcon icon={faSearch} className="search-icon" />
                <input
                    type="text"
                    placeholder="Buscar..."
                    value={searchTerm}
                    onChange={handleSearch}
                    className="input"
                />
            </div>
            {modalOpen && (
                <div className="modalInput">
                    {filteredEnlaces.length > 0 ? (
                        filteredEnlaces.map((enlace, index) => (
                            <div key={index}>

                                <Link to={enlace.link} onClick={closeModal} className='link'>
                                    <FontAwesomeIcon icon={faSignOutAlt} />
                                    {enlace.title}
                                </Link>
                            </div>
                        ))
                    ) : (
                        <p>No hay resultados.</p>
                    )}
                </div>
            )}
        </div>



    );
}
